var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"my-application"},[_c('EncabezadoPagina'),_c('v-main',{staticClass:"imagenFondo"},[_c('router-view')],1),_c('PiePagina',{attrs:{"mensaje":"¿Necesita ayuda?"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }